import React from "react";
// Assuming:
// logo is the AVANSE logo (The one on the right in the uploaded image)
// logo2 is the IDP logo (The one on the left in the uploaded image)
import logo from "./../images/avanse-logo.png";
import logo2 from "./../images/cm-uc-logo.png";

const Header = () => {
  // --- Embedded Custom CSS for Responsive Design ---
  const headerStyles = `
    /* 1. Base style: Ensures horizontal padding is 0 on mobile */
    .logo-padding-desktop {
      padding-left: 0 !important;
      padding-right: 0 !important;
    }

    /* 2. Style for Desktop/Large Screens */
    @media (min-width: 992px) {
      
      /* Reduce Height on Desktop: Apply minimal vertical padding to the header */
      .apply-now-header {
        padding-top: 5px !important;
        padding-bottom: 5px !important;
      }
      
      /* Apply 150px horizontal padding only on very large screens (xl breakpoint) */
      @media (min-width: 1200px) {
        /* Left Logo: 150px padding from the start */
        .logo-padding-desktop:first-child {
          padding-left: 12px !important;
        }

        /* Right Logo: 150px padding from the end */
        .logo-padding-desktop:last-child {
          padding-right: 5px !important;
        }
      }
    }
  `;

  return (
    <>
      {/* Inject the required responsive CSS styles */}
      <style>{headerStyles}</style>

      {/* Base Vertical Padding (py-2) and Mobile Horizontal Padding (px-3) */}
      <section className="apply-now-header py-2 px-3">
        <div className="container-fluid">
          {/* d-flex justify-content-between aligns logos to far left and far right */}
          <div className="d-flex justify-content-between align-items-center">
            {/* ### LOGO ON THE LEFT: IDP (logo2) - Matching the Figma/Image layout */}
            {/* col-auto reduces width on mobile, logo-padding-desktop controls 150px spacing */}
            <div className="col-auto logo-padding-desktop">
              <img src={logo} alt="IDP Logo" className="img-fluid" />
            </div>

            {/* ### LOGO ON THE RIGHT: AVANSE (logo) - Matching the Figma/Image layout */}
            <div className="col-auto text-end logo-padding-desktop">
              <img src={logo2} alt="Avanse Logo" className="img-fluid" />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Header;
